import {
  ANSWER_ACCEPTANCE,
  ANSWER_STATUS,
  QUESTIONNAIRE_STATUS,
  Question,
  Questionnaire,
} from '@trustero/trustero-api-web/lib/questionnaire/questionnaire_pb'

const getQuestionsWithAnswers = (questions: Question[]): Question[] =>
  questions.filter((question) => !!question.getAnswer())

export const getCompletedQuestions = (questions: Question[]): Question[] =>
  questions.filter(
    (question) => question.getAcceptance() === ANSWER_ACCEPTANCE.ACCEPTED,
  )

const getManuallyCompletedAnswers = (questions: Question[]): Question[] =>
  questions.filter(
    (question) =>
      question.getAcceptance() === ANSWER_ACCEPTANCE.ACCEPTED &&
      question.getStatus() === ANSWER_STATUS.USER_EDITED,
  )

const getEroCompletedAnswers = (questions: Question[]): Question[] =>
  questions.filter(
    (question) =>
      question.getAcceptance() === ANSWER_ACCEPTANCE.ACCEPTED &&
      question.getStatus() === ANSWER_STATUS.GENERATED,
  )

export const getQuestionnaireAnswerCount = (questions: Question[]): number =>
  getQuestionsWithAnswers(questions).length

export const getManuallyCompletedAnswerCount = (
  questions: Question[],
): number => getManuallyCompletedAnswers(questions).length

export const getEroCompletedAnswerCount = (questions: Question[]): number =>
  getEroCompletedAnswers(questions).length

export const getCompletedAnswerCount = (questions: Question[]): number =>
  getCompletedQuestions(questions).length

export const getPercentComplete = (questions: Question[]): number => {
  const total = questions.length
  const completed = getCompletedAnswerCount(questions)

  return (completed / total) * 100
}

export const isQuestionnaireScanning = (
  questionnaires: Questionnaire[],
): boolean =>
  !!questionnaires.find(
    (questionnaire) =>
      questionnaire.getStatus() === QUESTIONNAIRE_STATUS.INITIATED,
  )
